import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class PreguntasFrecuentesApi {
    
    static activar(id, token) {  
       return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/preguntasfrecuentes/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/preguntasfrecuentes/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getPreguntasFrecuentesList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/preguntasfrecuentes?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getPreguntasFrecuentes(id, token ) {  
         return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/preguntasfrecuentes/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(preguntasfrecuentes, token ) {          
      let preguntasfrecuentesEnvio = Object.assign({}, preguntasfrecuentes);
		let comando="POST";
		if (preguntasfrecuentesEnvio.id > 0) {
			comando="PUT";			
		} 
		preguntasfrecuentesEnvio=JSON.stringify(preguntasfrecuentesEnvio);
		return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/preguntasfrecuentes/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: preguntasfrecuentesEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    static getPreguntasFrecuentesCombo(token ) {

		return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/preguntasfrecuentes/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}